import React, { useState, useEffect } from "react";
import "./UserProfilePopup.css";
import { registerUser } from "../../services/userService"; // ✅ Import User Service
import { getAllRoles } from "../../services/userService"; // ✅ Import Role Service
import Popup from "../../components/ui/Popup"; // ✅ Success/Error Popup

const UserProfilePopup = ({ isOpen, onClose, onProfileCreated, selectedEmployee }) => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        roleId: "",
        employeeNic: selectedEmployee ? selectedEmployee.NIC : "", // Load from selected employee
        statusId: 1, // Default to active
    });

    const [roles, setRoles] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    // ✅ Load roles on mount
    useEffect(() => {
        loadRoles();
    }, []);

    useEffect(() => {
        console.log("Selected Employee:", selectedEmployee);
        if (selectedEmployee) {
            setFormData((prevData) => ({
                ...prevData,
                employeeNic: selectedEmployee.NIC || "",
            }));
        }
    }, [selectedEmployee]);

    const loadRoles = async () => {
        try {
            const response = await getAllRoles();
            console.log("Fetched Roles:", response); // Check exact structure
            setRoles(response || []); // Assign response directly
        } catch (error) {
            console.error("Error loading roles:", error);
        }
    };


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.username || !formData.password || !formData.roleId || !formData.employeeNic) {
            setErrorMessage("All fields are required!");
            return;
        }

        // ✅ Convert to correct format
        const formattedData = {
            username: formData.username,
            password: formData.password,
            roleId: Number(formData.roleId),  // Ensure it's a number
            employeeNic: formData.employeeNic,
            statusId: Number(formData.statusId)  // Ensure it's a number
        };

        console.log("Sending User Data:", formattedData); // ✅ Check format in console

        try {
            await registerUser(formattedData);
            setPopupMessage("User profile created successfully!");
            setShowPopup(true);

            setTimeout(() => {
                setShowPopup(false);
                onClose();
                onProfileCreated();
            }, 2000);

        } catch (error) {
            console.error("Error registering user:", error);
            setErrorMessage("Failed to create user profile.");

        }
    };


    if (!isOpen) return null;

    return (
        <div className="profile-popup-overlay">
            <div className="profile-popup-content">
                <button className="close-btn" onClick={onClose}>✕</button>
                <h2>Create User Profile</h2>

                {errorMessage && <p className="error-message">{errorMessage}</p>}
                {successMessage && <p className="success-message">{successMessage}</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username:</label>
                        <input type="text" name="username" value={formData.username} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Password:</label>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Role:</label>
                        <select name="roleId" value={formData.roleId} onChange={handleChange}>
                            <option value="">Select Role</option>
                            {(roles || []).map((role) => (
                                <option key={role.id} value={role.id}>{role.role_name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Employee NIC:</label>
                        {/* ✅ Display the NIC as read-only */}
                        <input
                            type="text"
                            name="employeeNic"
                            value={formData.employeeNic || ""}
                            readOnly
                        />
                    </div>


                    <div className="form-group">
                        <label>Status:</label>
                        <select name="statusId" value={formData.statusId} onChange={handleChange}>
                            <option value="1">Active</option>
                            <option value="0">Deactivated</option>
                        </select>
                    </div>

                    <button type="submit" className="create-profile-btn">Create Profile</button>
                </form>
            </div>
            {/* ✅ Popup Notification for Validation Errors & Success Messages */}
            {showPopup && <Popup message={popupMessage} onClose={() => setShowPopup(false)} />}

        </div>
    );
};

export default UserProfilePopup;
